<template>
  <div class="statistics">
    <div style="padding: 0px 20px;height: 100%">
      <div class="search">
        <div v-for="item in search" :class='["search_options_box"]'>
          <span style="width: 100px;">{{item.title}}</span>
          <el-select class="select" v-model="selectValue" placeholder="请选择项目" @change="getOnStatic()">
            <el-option v-for="item2 in item.options" :label="item2.label" :value="item2.value" :key="item2.value"></el-option>
          </el-select>
        </div>
      </div>

      <div class="statistical_overview">
        <div v-for="(item,index) in statistical" class="statistical_box">
          <div :style="[{background:'url('+item.icon+') no-repeat center center'}]"></div>
          <div>
            <p :style="[{color:item.color}]">{{item.name}}</p>
            <span :style="[{color:item.color}]">{{model[index].name}}</span>
          </div>
        </div>
      </div>

      <div :class='["information_box","light_border"]'
           :style="[{width:'calc(50% - 12px)'},{'min-height':'350px'},{height:'36.5%'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button @click="income_day()" class="income_btn focus">近十五日收入</button>
            <button @click="income_month()" class="income_btn">每月收入</button>
            <button @click="income_quarter()" class="income_btn">每季收入</button>
          </div>
          <div id="income"></div>
        </div>
      </div>

      <div :class='["information_box","light_border"]'
           :style="[{width:'calc(50% - 12px)'},{'min-height':'350px'},{height:'36.5%'},{marginLeft:'20px'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button @click="flow_day()" class="income_btn focus">每日流量统计</button>
            <button @click="flow_month()" class="income_btn">每月流量统计</button>
            <button @click="flow_quarter()" class="income_btn">每季流量统计</button>
          </div>
          <div id="flow"></div>
        </div>
      </div>

      <div :class='["information_box","light_border"]'
           :style="[{width:'calc(50% - 12px)'},{'min-height':'350px'},{height:'36.5%'},{marginBottom:'20px'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button @click="user_day()" class="income_btn focus">本日在线用户数</button>
            <button @click="user_month()" class="income_btn">本月在线用户数</button>
            <button @click="user_quarter()" class="income_btn">本季在线用户数</button>
          </div>
          <div id="user"></div>
        </div>
      </div>

      <div :style="[{'min-height':'350px'},{height:'36.5%'},{marginBottom:'20px'}]">
        <div :class='["information_box","light_border"]'
             :style="[{width:'calc(50% - 12px)'},{height:'calc(100% - 75px)'},{marginLeft:'20px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content" style="padding-bottom:20px;height:265px;overflow-y: auto">
            <div class="win_title"></div>
            <div style="height: 225px;overflow-y: auto">
              <div v-for="item in article" class="article">
                <ul>
                  <li><span class="emergency">{{item.emergency}}</span></li>
                  <li class="article_title">{{item.title}}</li>
                  <li class="article_time">{{item.time}}</li>
                  <li class="article_content">{{item.content}}</li>
                </ul>
              </div>
              <div class="article">
                <ul>
                  <li class="article_title"><span class="emergency">紧急</span>关于石桥房VPN升级通知</li>
                  <li class="article_time">2019-07-23 <span>13:10</span></li>
                  <li class="article_content">为提高设备运行稳定性，运营支撑部计划系统深信服厂商于2019年2月25日20:30对石桥左侧道附近的VPN进行检修升级，这里是文章简介示例...
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
        <div :class='["information_box","light_border"]'
             :style="[{width:'calc(50% - 12px)'},{height:'55px'},{marginLeft:'20px'}]">
          <button class="view_more">查看更多</button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  //引入echarts
  let echarts = require('echarts/lib/echarts');
  // 引入柱状图组件
  require('echarts/lib/chart/bar');
  require('echarts/lib/chart/line');
  require('echarts/lib/chart/scatter');
  require('echarts/lib/chart/effectScatter');
  // 引入提示框和title组件
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/title');
  require('echarts/lib/component/legend');
  require('echarts/lib/component/geo');


  export default {
    name: "statistics",
    data() {
      return {
        search: [
          {
            title: '选择项目',
            options: [],
          },
        ],
        selectValue:'17e3b71e-b460-498e-b0ef-657d20bd6549',
        projectList:[],
        statistical: [
          {name: "设备总数", icon: "/static/img/equipment_number1.png", color: "#f5b03b"},
          {name: "设备在线数", icon: "/static/img/equipment_number2.png", color: "#76bbff"},
          {name: "当前使用人数", icon: "/static/img/equipment_number3.png", color: "#bd74ed"},
          {name: "广告总数", icon: "/static/img/equipment_number4.png", color: "#3cda97"},
          {name: "累计收益", icon: "/static/img/equipment_number5.png", color: "#ff7b79"},
        ],
        model: [
          {name: 4},
          {name: 3},
          {name: "0"},
          {name: "0"},
          {name: "0"},
        ],
        article: [
          {
            emergency: '紧急',
            title: '关于石桥房VPN升级通知',
            time: '2019-07-23 13:23',
            content: '为提高设备运行稳定性，运营支撑部计划系统深信服厂商于2019年2月25日20:30对石桥左侧道附近的VPN进行检修升级，这里是文章简介示例...'
          },
          {
            title: '关于石桥房VPN升级通知',
            time: '2019-07-23 13:23',
            content: '为提高设备运行稳定性，运营支撑部计划系统深信服厂商于2019年2月25日20:30对石桥左侧道附近的VPN进行检修升级，这里是文章简介示例...'
          }
        ],
        //缓存数组
        income_date_day: [
          {name: "今日", value: 215},
          {name: "08-16", value: 315},
          {name: "08-15", value: 925},
          {name: "08-14", value: 1235},
          {name: "08-13", value: 211},
          {name: "08-12", value: 131},
          {name: "08-11", value: 956},
          {name: "08-10", value: 821},
          {name: "08-09", value: 625},
          {name: "08-08", value: 315},
          {name: "08-07", value: 995},
          {name: "08-06", value: 316},
          {name: "08-05", value: 712},
          {name: "08-04", value: 525},
          {name: "08-03", value: 321},
        ],
        income_data_month: [
          {name: "1月", value: 3215},
          {name: "2月", value: 13245},
          {name: "3月", value: 12323},
          {name: "4月", value: 64514},
          {name: "5月", value: 5641},
          {name: "6月", value: 65498},
          {name: "7月", value: 12356},
          {name: "8月", value: 6132},
          {name: "9月", value: 6561},
          {name: "10月", value: 8547},
          {name: "11月", value: 21455},
          {name: "12月", value: 65498},
        ],
        income_data_quarter: [
          {name: "第一季度", value: 321445},
          {name: "第二季度", value: 133245},
          {name: "第三季度", value: 132323},
          {name: "第四季度", value: 264514},
        ],


        user_data_day: [
          {name: "0时", value: 215},
          //{name: "1时", value: 315},
          {name: "2时", value: 425},
          //{name: "3时", value: 235},
          {name: "4时", value: 211},
          //{name: "5时", value: 131},
          {name: "6时", value: 236},
          //{name: "7时", value: 321},
          {name: "8时", value: 325},
          //{name: "9时", value: 315},
          {name: "10时", value: 395},
          //{name: "11时", value: 316},
          {name: "12时", value: 312},
          //{name: "13时", value: 325},
          {name: "14时", value: 321},
          //{name: "15时", value: 395},
          {name: "16时", value: 316},
          //{name: "17时", value: 312},
          {name: "18时", value: 325},
          //{name: "19时", value: 321},
          {name: "20时", value: 281},
          //{name: "21时", value: 191},
          {name: "22时", value: 241},
          //{name: "23时", value: 321},
        ],
        user_data_mouth: [
          {name: "1", value: 215},
          //{name: "2", value: 315},
          {name: "3", value: 925},
          //{name: "4", value: 1235},
          {name: "5", value: 211},
          //{name: "6", value: 131},
          {name: "7", value: 236},
          //{name: "8", value: 321},
          {name: "9", value: 325},
          //{name: "10", value: 315},
          {name: "11", value: 395},
          //{name: "12", value: 316},
          {name: "13", value: 312},
          //{name: "14", value: 325},
          {name: "15", value: 321},
          //{name: "16", value: 325},
          {name: "17", value: 315},
          //{name: "18", value: 395},
          {name: "19", value: 316},
          //{name: "20", value: 312},
          {name: "21", value: 325},
          //{name: "22", value: 321},
          {name: "23", value: 312},
          //{name: "24", value: 325},
          {name: "25", value: 321},
          //{name: "26", value: 312},
          {name: "27", value: 325},
          //{name: "28", value: 321},
          {name: "29", value: 312},
          //{name: "30", value: 325},
        ],
        user_data_quarter: [
          {name: "6月", value: 65498},
          {name: "7月", value: 52356},
          {name: "8月", value: 46132},
        ],

        flow_data_day: [
          {name: "0时", value: 215,value2:430},
          //{name: "1时", value: 315,value2:251},
          {name: "2时", value: 425,value2:218},
          //{name: "3时", value: 235,value2:153},
          {name: "4时", value: 211,value2:123},
          //{name: "5时", value: 131,value2:185},
          {name: "6时", value: 236,value2:143},
          //{name: "7时", value: 321,value2:165},
          {name: "8时", value: 325,value2:132},
          //{name: "9时", value: 315,value2:281},
          {name: "10时", value: 395,value2:147},
          //{name: "11时", value: 316,value2:241},
          {name: "12时", value: 312,value2:214},
          //{name: "13时", value: 325,value2:211},
          {name: "14时", value: 321,value2:214},
          //{name: "15时", value: 395,value2:241},
          {name: "16时", value: 316,value2:231},
          //{name: "17时", value: 312,value2:126},
          {name: "18时", value: 325,value2:189},
          //{name: "19时", value: 321,value2:131},
          {name: "20时", value: 321,value2:175},
          //{name: "21时", value: 321,value2:123},
          {name: "22时", value: 321,value2:196},
          //{name: "23时", value: 321,value2:234},
        ],
        flow_data_month: [
          {name: "1", value: 1215,value2: 915},
          {name: "2", value: 1315,value2: 962},
          {name: "3", value: 1125,value2: 921},
          {name: "4", value: 1235,value2: 1085},
          {name: "5", value: 1211,value2: 1026},
          {name: "6", value: 1131,value2: 993},
          {name: "7", value: 1236,value2: 934},
          {name: "8", value: 1321,value2: 1041},
          {name: "9", value: 1325,value2: 1256},
          {name: "10", value: 1315,value2: 1215},
          {name: "11", value: 1595,value2: 1095},
          {name: "12", value: 1316,value2: 1210},
          {name: "13", value: 1312,value2: 1125},
          {name: "14", value: 1325,value2: 1124},
          {name: "15", value: 1421,value2: 1212},
          {name: "16", value: 1325,value2: 1324},
          {name: "17", value: 1315,value2: 1234},
          {name: "18", value: 1395,value2: 1234},
          {name: "19", value: 1316,value2: 1296},
          {name: "20", value: 1112,value2: 1131},
          {name: "21", value: 1255,value2: 1065},
          {name: "22", value: 1215,value2: 1034},
          {name: "23", value: 1312,value2: 1374},
          {name: "24", value: 1325,value2: 1231},
          {name: "25", value: 1321,value2: 1194},
          {name: "26", value: 1412,value2: 1234},
          {name: "27", value: 1325,value2: 1352},
          {name: "28", value: 1281,value2: 1234},
          {name: "29", value: 1112,value2: 1298},
          {name: "30", value: 1325,value2: 1212},
        ],
        flow_data_quarter: [
          {name: "6月", value: 5498, value2: 6498},
          {name: "7月", value: 12356, value2: 4498},
          {name: "8月", value: 6132, value2: 8498},
        ],

      }
    },
    mounted() {
      $(function () {
        $('.income_btn').click(function () {
          $(this).addClass('focus').siblings().removeClass('focus');
        });
      });
      this.getOnStatic();
      //初始化表格
      this.income_day();
      this.user_day();
      this.flow_day();

    },
    created(){
      this.InitLeftMenu();
      this.getProjectList();
    },
    methods: {
      InitLeftMenu:function () {
        this.$emit('getMessage', '3','0');
      },


      getOnStatic:function(){
        fetch("/api/v1/statistics", {
          method: 'post',
          body: JSON.stringify({
            project_id:this.selectValue
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            this.model[0].name = data.data.wifi.total_count;
            this.model[1].name = data.data.wifi.online_count;
            this.model[2].name = data.data.wifi.online_user_count;
          })
      },


      //获取项目列表
      getProjectList:function(){
        fetch("/api/v1/project/list", {
          method: 'post',
          body: JSON.stringify({

          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "项目数据获取成功";
              this.projectList = data.data;
              let options = this.search[0].options;
              for (let i=0;i<this.projectList.length;i++){
                let projectObj = {};
                projectObj.label = this.projectList[i].name;
                projectObj.value = this.projectList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      income_day: function () {
        // if(this.income_data_quarter!==""){
        //   // this.$axios.get("",{
        //   //
        //   // }).then((res)=>{
        //   //    this.income_data_quarter = res
        //   // })
        // }
        let date = [];
        let data = [];
        for (let i = 0; i < this.income_date_day.length; i++) {
          date.push(this.income_date_day[i].name);
          data.push(this.income_date_day[i].value);
        }
        let myChart1 = echarts.init(document.getElementById('income'));
        myChart1.setOption({
          tooltip: {},
          grid: {
            left: "2%",
            right: "2%",
            top: "12%",
            bottom: "10%",
            containLabel: true
          },
          xAxis: [{
            type: "category",
            data: date,
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",

              }
            },
            offset: 5,
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            }
          }],
          yAxis: [{
            name: "收入总额(万元)",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff"
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          }],
          series: [{
            name: "",
            type: "pictorialBar",
            symbolSize: [20, 10],
            symbolOffset: [0, -5],
            symbolPosition: "end",
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#18884d"
              },
            },
            z: 12,
            label: {
              normal: {
                show: true,
                position: "top",
                formatter: "{c}",
                textStyle: {
                  color: "#00f0ff"
                },
              },
            },
            data: data
          }, {
            name: "",
            type: "pictorialBar",
            symbolSize: [20, 10],
            symbolOffset: [0, 5],
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#21b868"
              },
            },
            z: 12,
            data: data,
          }, {
            type: "bar",
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#21b868"
              },
            },
            barWidth: "20",
            data: data
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },

      income_month: function () {
        // if(this.income_data_quarter!==""){
        //   // this.$axios.get("",{
        //   //
        //   // }).then((res)=>{
        //   //    this.income_data_quarter = res
        //   // })
        // }
        let date = [];
        let data = [];
        for (let i = 0; i < this.income_data_month.length; i++) {
          date.push(this.income_data_month[i].name);
          data.push(this.income_data_month[i].value);
        }
        var myChart1 = echarts.init(document.getElementById('income'));
        myChart1.setOption({
          tooltip: {},
          grid: {
            left: "2%",
            right: "2%",
            top: "12%",
            bottom: "10%",
            containLabel: true
          },
          xAxis: [{
            type: "category",
            data: date,
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",

              }
            },
            offset: 5,
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            }
          }],
          yAxis: [{
            name: "收入总额(万元)",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff"
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          }],
          series: [{
            name: "",
            type: "pictorialBar",
            symbolSize: [20, 10],
            symbolOffset: [0, -5],
            symbolPosition: "end",
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#18884d"
              },
            },
            z: 12,
            label: {
              normal: {
                show: true,
                position: "top",
                formatter: "{c}",
                textStyle: {
                  color: "#00f0ff"
                },
              },
            },
            data: data
          }, {
            name: "",
            type: "pictorialBar",
            symbolSize: [20, 10],
            symbolOffset: [0, 5],
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#21b868"
              },
            },
            z: 12,
            data: data
          }, {
            type: "bar",
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#21b868"
              },
            },
            barWidth: "20",
            data: data
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },

      income_quarter: function () {
        // if(this.income_data_quarter!==""){
        //   // this.$axios.get("",{
        //   //
        //   // }).then((res)=>{
        //   //    this.income_data_quarter = res
        //   // })
        // }
        let date = [];
        let data = [];
        for (let i = 0; i < this.income_data_quarter.length; i++) {
          date.push(this.income_data_quarter[i].name);
          data.push(this.income_data_quarter[i].value);
        }
        var myChart1 = echarts.init(document.getElementById('income'));
        myChart1.setOption({
          tooltip: {},
          grid: {
            left: "2%",
            right: "2%",
            top: "12%",
            bottom: "10%",
            containLabel: true
          },
          xAxis: [{
            type: "category",
            data: date,
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",

              }
            },
            offset: 5,
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            }
          }],
          yAxis: [{
            name: "收入总额(万元)",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff"
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          }],
          series: [{
            name: "",
            type: "pictorialBar",
            symbolSize: [20, 10],
            symbolOffset: [0, -5],
            symbolPosition: "end",
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#18884d"
              },
            },
            z: 12,
            label: {
              normal: {
                show: true,
                position: "top",
                formatter: "{c}",
                textStyle: {
                  color: "#00f0ff"
                },
              },
            },
            data: data
          }, {
            name: "",
            type: "pictorialBar",
            symbolSize: [20, 10],
            symbolOffset: [0, 5],
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#21b868"
              },
            },
            z: 12,
            data: data,
          }, {
            type: "bar",
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#21b868"
              },
            },
            barWidth: "20",
            data: data,
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },

      user_day: function () {
        let date = [];
        let data = [];
        for (let i = 0; i < this.user_data_day.length; i++) {
          date.push(this.user_data_day[i].name);
          data.push(this.user_data_day[i].value);
        }
        let myChart1 = echarts.init(document.getElementById('user'));
        myChart1.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow',        // 默认为直线，可选为：'line' | 'shadow'
              shadowStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: 'rgba(1,200,179,0)' // 0% 处的颜色
                  }, {
                    offset: 1, color: 'rgba(1,200,179,1)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                },
                opacity: 0.35
              }
            },
          },
          grid: {
            left: "5%",
            right: "5%",
            top: "12%",
            bottom: "10%",
            containLabel: true
          },
          xAxis: [{
            type: "category",
            data: date,
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",

              }
            },
            offset: 5,
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            }
          }],
          yAxis: [{
            name: "人次",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: false,
              textStyle: {
                color: "#ffffff"
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          }],
          series: [{
            type: "line",
            smooth: true,
            symbolSize: 12,
            symbol: 'circle',
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#01c8b3",
                shadowColor: 'rgba(0,156,140,0.35)',
                shadowBlur: 5,
                shadowOffsetY: 5
              },
            },
            lineStyle: {
              width: 4,
              color: '#01c8b3',
              shadowColor: 'rgba(72,216,191, 0.3)',
              shadowBlur: 5,
              shadowOffsetY: 5
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 20,
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ],
              label: {
                show: true,
                position: "top",
                color: '#ffffff'
              }
            },
            markLine: {
              symbol: 'none',
              label: {
                position: "left",
                formatter: '{c}',
                color:"#ffffff",
              },
              data: [
                {
                  name: "最大值",
                  type: 'max',//res.targetTwo,
                  lineStyle: {
                    color: "#244465"
                  },
                }, {
                  name: "最小值",
                  type: 'min',//res.targetTwo,
                  lineStyle: {
                    color: "#244465"
                  },
                }
              ]
            },
            data: data
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },

      user_month: function () {
        // if(this.income_data_quarter!==""){
        //   // this.$axios.get("",{
        //   //
        //   // }).then((res)=>{
        //   //    this.income_data_quarter = res
        //   // })
        // }
        let date = [];
        let data = [];
        for (let i = 0; i < this.user_data_mouth.length; i++) {
          date.push(this.user_data_mouth[i].name);
          data.push(this.user_data_mouth[i].value);
        }
        let myChart1 = echarts.init(document.getElementById('user'));
        myChart1.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow',        // 默认为直线，可选为：'line' | 'shadow'
              shadowStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: 'rgba(1,200,179,0)' // 0% 处的颜色
                  }, {
                    offset: 1, color: 'rgba(1,200,179,1)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                },
                opacity: 0.35
              }
            },
          },
          grid: {
            left: "5%",
            right: "5%",
            top: "12%",
            bottom: "10%",
            containLabel: true
          },
          xAxis: [{
            type: "category",
            data: date,
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",

              }
            },
            offset: 5,
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            }
          }],
          yAxis: [{
            name: "人次",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: false,
              textStyle: {
                color: "#ffffff"
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          }],
          series: [{
            type: "line",
            smooth: true,
            symbolSize: 12,
            symbol: 'circle',
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#01c8b3",
                shadowColor: 'rgba(0,156,140,0.35)',
                shadowBlur: 5,
                shadowOffsetY: 5
              },
            },
            lineStyle: {
              width: 4,
              color: '#01c8b3',
              shadowColor: 'rgba(72,216,191, 0.3)',
              shadowBlur: 5,
              shadowOffsetY: 5
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 20,
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ],
              label: {
                show: true,
                position: "top",
                color: '#ffffff'
              }
            },
            markLine: {
              symbol: 'none',
              label: {
                position: "left",
                formatter: '{c}',
                color:"#ffffff",
              },
              data: [
                {
                  name: "最大值",
                  type: 'max',//res.targetTwo,
                  lineStyle: {
                    color: "#244465"
                  },
                }, {
                  name: "最小值",
                  type: 'min',//res.targetTwo,
                  lineStyle: {
                    color: "#244465"
                  },
                }
              ]
            },
            data: data
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },

      user_quarter: function () {
        // if(this.income_data_quarter!==""){
        //   // this.$axios.get("",{
        //   //
        //   // }).then((res)=>{
        //   //    this.income_data_quarter = res
        //   // })
        // }
        let date = [];
        let data = [];
        for (let i = 0; i < this.user_data_quarter.length; i++) {
          date.push(this.user_data_quarter[i].name);
          data.push(this.user_data_quarter[i].value);
        }
        let myChart1 = echarts.init(document.getElementById('user'));
        myChart1.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow',        // 默认为直线，可选为：'line' | 'shadow'
              shadowStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: 'rgba(1,200,179,0)' // 0% 处的颜色
                  }, {
                    offset: 1, color: 'rgba(1,200,179,1)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                },
                opacity: 0.35
              }
            },
          },
          grid: {
            left: "5%",
            right: "5%",
            top: "12%",
            bottom: "10%",
            containLabel: true
          },
          xAxis: [{
            type: "category",
            data: date,
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",

              }
            },
            offset: 5,
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            }
          }],
          yAxis: [{
            name: "人次",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: false,
              textStyle: {
                color: "#ffffff"
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          }],
          series: [{
            type: "line",
            smooth: true,
            symbolSize: 12,
            symbol: 'circle',
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#01c8b3",
                shadowColor: 'rgba(0,156,140,0.35)',
                shadowBlur: 5,
                shadowOffsetY: 5
              },
            },
            lineStyle: {
              width: 4,
              color: '#01c8b3',
              shadowColor: 'rgba(72,216,191, 0.3)',
              shadowBlur: 5,
              shadowOffsetY: 5
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 20,
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ],
              label: {
                show: true,
                position: "top",
                color: '#ffffff'
              }
            },
            markLine: {
              symbol: 'none',
              label: {
                position: "left",
                formatter: '{c}',
                color:"#ffffff",
              },
              data: [
                {
                  name: "最大值",
                  type: 'max',//res.targetTwo,
                  lineStyle: {
                    color: "#244465"
                  },
                }, {
                  name: "最小值",
                  type: 'min',//res.targetTwo,
                  lineStyle: {
                    color: "#244465"
                  },
                }
              ]
            },
            data: data
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },

      flow_day: function () {
        // if(this.income_data_quarter!==""){
        //   // this.$axios.get("",{
        //   //
        //   // }).then((res)=>{
        //   //    this.income_data_quarter = res
        //   // })
        // }
        let date = [];
        let data1 = [];
        let data2 = [];
        for (let i = 0; i < this.flow_data_day.length; i++) {
          date.push(this.flow_data_day[i].name);
          data1.push(this.flow_data_day[i].value);
          data2.push(this.flow_data_day[i].value2);
        }
        let myChart1 = echarts.init(document.getElementById('flow'));
        myChart1.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'line',        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            data:['上行总量','下行总量'],
            itemWidth:10,
            itemHeight:10,
            right:'5%',
            icon:'bar',
            textStyle: {
              fontSize: '12',
              color:'#fff'
            }
          },
          grid: {
            left: "5%",
            right: "5%",
            top: "12%",
            bottom: "10%",
            containLabel: true
          },
          xAxis: [{
            type: "category",
            boundaryGap: false,
            data: date,
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",

              }
            },
            offset: 5,
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            }
          }],
          yAxis: [{
            name: "流量统计（单位:KG）",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff"
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          }],
          series: [{
            name: '上行总量',
            type: 'line',
            smooth: true, //是否平滑曲线显示
			      symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            symbolSize:10,
            showSymbol: false,
            lineStyle: {
              normal: {
                color: 'rgba(139,210,255, 0.2)'  // 线条颜色
              }
            },
            itemStyle:{
              normal:{
                color: 'rgba(139,210,255,1)'
              }
            },
            areaStyle: { //区域填充样式
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0,  color: 'rgba(139,210,255, 1)'},
                  { offset: 0.7,  color: 'rgba(96,163,255, 1)'}
                ], false),

                shadowColor: 'rgba(53,142,215, 0.9)', //阴影颜色
                shadowBlur: 20 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
              }
            },
            data: data1
          },{
            name: '下行总量',
            type: 'line',
            smooth: true, //是否平滑曲线显示
			      symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            symbolSize:10,
            showSymbol: false,
            lineStyle: {
              normal: {
                color: 'rgba(171,139,255,0.4)'
              }
            },
            itemStyle:{
              normal:{
                color: "#a287ea"   // 线条颜色
              }
            },
            areaStyle: { //区域填充样式
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0,  color: '#ab8bff'},
                  { offset: 1,  color: '#a287ea'}
                ], false),
              }
            },
            data: data2
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },

      flow_month: function () {
        // if(this.income_data_quarter!==""){
        //   // this.$axios.get("",{
        //   //
        //   // }).then((res)=>{
        //   //    this.income_data_quarter = res
        //   // })
        // }
        let date = [];
        let data1 = [];
        let data2 = [];
        for (let i = 0; i < this.flow_data_month.length; i++) {
          date.push(this.flow_data_month[i].name);
          data1.push(this.flow_data_month[i].value);
          data2.push(this.flow_data_month[i].value2);
        }
        let myChart1 = echarts.init(document.getElementById('flow'));
        myChart1.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'line',        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            data:['上行总量','下行总量'],
            itemWidth:10,
            itemHeight:10,
            right:'5%',
            icon:'bar',
            textStyle: {
              fontSize: '12',
              color:'#fff'
            }
          },
          grid: {
            left: "5%",
            right: "5%",
            top: "12%",
            bottom: "10%",
            containLabel: true
          },
          xAxis: [{
            type: "category",
            boundaryGap: false,
            data: date,
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",

              }
            },
            offset: 5,
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            }
          }],
          yAxis: [{
            name: "流量统计（单位:KG）",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff"
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          }],
          series: [{
            name: '上行总量',
            type: 'line',
            smooth: true, //是否平滑曲线显示
            symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            symbolSize:10,
            showSymbol: false,
            lineStyle: {
              normal: {
                color: 'rgba(139,210,255, 0.2)'  // 线条颜色
              }
            },
            itemStyle:{
              normal:{
                color: 'rgba(139,210,255,1)'
              }
            },
            areaStyle: { //区域填充样式
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0,  color: 'rgba(139,210,255, 1)'},
                  { offset: 0.7,  color: 'rgba(96,163,255, 1)'}
                ], false),

                shadowColor: 'rgba(53,142,215, 0.9)', //阴影颜色
                shadowBlur: 20 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
              }
            },
            data: data1
          },{
            name: '下行总量',
            type: 'line',
            smooth: true, //是否平滑曲线显示
            symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            symbolSize:10,
            showSymbol: false,
            lineStyle: {
              normal: {
                color: 'rgba(171,139,255,0.4)'
              }
            },
            itemStyle:{
              normal:{
                color: "#a287ea"   // 线条颜色
              }
            },
            areaStyle: { //区域填充样式
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0,  color: '#ab8bff'},
                  { offset: 1,  color: '#a287ea'}
                ], false),
              }
            },
            data: data2
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },

      flow_quarter: function () {
        // if(this.income_data_quarter!==""){
        //   // this.$axios.get("",{
        //   //
        //   // }).then((res)=>{
        //   //    this.income_data_quarter = res
        //   // })
        // }
        let date = [];
        let data1 = [];
        let data2 = [];
        for (let i = 0; i < this.flow_data_quarter.length; i++) {
          date.push(this.flow_data_quarter[i].name);
          data1.push(this.flow_data_quarter[i].value);
          data2.push(this.flow_data_quarter[i].value2);
        }
        let myChart1 = echarts.init(document.getElementById('flow'));
        myChart1.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'line',        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            data:['上行总量','下行总量'],
            itemWidth:10,
            itemHeight:10,
            right:'5%',
            icon:'bar',
            textStyle: {
              fontSize: '12',
              color:'#fff'
            }
          },
          grid: {
            left: "5%",
            right: "5%",
            top: "12%",
            bottom: "10%",
            containLabel: true
          },
          xAxis: [{
            type: "category",
            boundaryGap: false,
            data: date,
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",

              }
            },
            offset: 5,
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            }
          }],
          yAxis: [{
            name: "流量统计（单位:KG）",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff"
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          }],
          series: [{
            name: '上行总量',
            type: 'line',
            smooth: true, //是否平滑曲线显示
            symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            symbolSize:10,
            showSymbol: false,
            lineStyle: {
              normal: {
                color: 'rgba(139,210,255, 0.2)'  // 线条颜色
              }
            },
            itemStyle:{
              normal:{
                color: 'rgba(139,210,255,1)'
              }
            },
            areaStyle: { //区域填充样式
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0,  color: 'rgba(139,210,255, 1)'},
                  { offset: 0.7,  color: 'rgba(96,163,255, 1)'}
                ], false),

                shadowColor: 'rgba(53,142,215, 0.9)', //阴影颜色
                shadowBlur: 20 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
              }
            },
            data: data1
          },{
            name: '下行总量',
            type: 'line',
            smooth: true, //是否平滑曲线显示
            symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            symbolSize:10,
            showSymbol: false,
            lineStyle: {
              normal: {
                color: 'rgba(171,139,255,0.4)'
              }
            },
            itemStyle:{
              normal:{
                color: "#a287ea"   // 线条颜色
              }
            },
            areaStyle: { //区域填充样式
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0,  color: '#ab8bff'},
                  { offset: 1,  color: '#a287ea'}
                ], false),
              }
            },
            data: data2
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },
    }

  }
</script>

<style scoped>
  .statistics {
    width: 100%;
    height: 100%;
  }

  .search {
    width: 100%;
    height: 76px;
  }

  .search_options_box {
    width: 275px;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #5a7595;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 36px;
    right: 20px;
    cursor: pointer;
  }

  .statistical_overview {
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: space-between;
  }

  .statistical_box {
    width: calc(20% - 16px);
    height: 100%;
    background-color: #0b2f54;
    border-radius: 6px;
    border: 1px solid #5a7192;
    -webkit-box-shadow: 0 0 10px #16518d inset;
    box-shadow: 0 0 10px #16518d inset;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .statistical_box > div:nth-child(1) {
    width: 80px;
    height: 80px;
    margin: 0px 20px;
  }

  .statistical_box > div:nth-child(2) {
    font-size: 20px;
    font-weight: bold;
  }

  .nva_btn {
    padding: 20px;
  }

  .income_btn {
    background: transparent;
    font-size: 16px;
    border: transparent;
    outline: transparent;
    color: #95bee5;
    margin-right: 20px;
  }

  .focus {
    font-size: 18px;
    color: #00f0ff;
  }

  .view_more {
    width: 100%;
    height: 100%;
    color: #00f0ff;
    background: transparent;
    border: transparent;
    outline: transparent;
  }

  .win_title {
    height: 22px;
    background: url("/static/img/win_title.png") no-repeat;
    margin: 15px 20px 0px 20px;
  }

  .article {
    padding: 15px 20px 0px 20px;
  }

  .emergency {
    float: left;
    width: 44px;
    line-height: 21px;
    text-align: center;
    font-size: 12px;
    color: #FFFFFF;
    background: #ff0000;
    border-radius: 4px;
    margin-right: 10px;
  }

  .article_title {
    font-size: 20px;
    color: #00f0ff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
  }

  .article_time {
    font-size: 14px;
    color: #FFFFFF;
    opacity: 0.1;
    margin: 5px 0px;
  }

  .article_content {
    font-size: 16px;
    color: #95bee5;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  #income, #flow, #user {
    width: 100%;
    height: calc(100% - 67px);
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/4_wifi/statistics.vue